import type { WaterProfile } from './types';

// Default hard-water profile (typical mid-plains agricultural water).
// Replace with tenant-configured values when water-profile editing UI ships.
export const DEFAULT_WATER_PROFILE: WaterProfile = {
    calciumPpm: 80,
    hardnessCaCO3Ppm: 260,
    ironPpm: 0.3,
    magnesiumPpm: 25,
    ph: 7.8,
    potassiumPpm: 20,
    sodiumPpm: 40
};
